export default __webpack_public_path__ + "static/media/plus-svg.bff2a0bf.svg";